import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** BTU/h = MCF/h · HHV — gas meter, burner, flue; fuel rate → heat rate. */
export function DiagramBoilerFireRate() {
  const bx = 130, by = 85, bw = 120, bh = 115;

  return (
    <DiagramCanvas>
      {/* Boiler shell */}
      <Rect x={bx} y={by} width={bw} height={bh} rx="8" fill={DT.fill} stroke={DT.stroke} strokeWidth="1.8" />
      {[0, 1, 2].map(i => (
        <Line key={i} x1={bx + 12} y1={by + 30 + i * 20} x2={bx + bw - 12} y2={by + 30 + i * 20}
          stroke={DT.stroke} strokeWidth="0.6" opacity={0.35} strokeDasharray="5,3" />
      ))}
      <SvgText x={bx + bw / 2} y={by + bh - 6} fill={DT.desc} fontSize="8" fontFamily={DT.mono} textAnchor="middle">BOILER</SvgText>

      {/* Gas meter (clock-face) */}
      <Circle cx={55} cy={170} r={20} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.6" />
      <Circle cx={55} cy={170} r={15} fill="none" stroke={DT.varColor} strokeWidth="0.6" />
      {[0, 45, 90, 135, 180, 225, 270, 315].map(d => {
        const r = d * Math.PI / 180;
        return <Line key={d} x1={55 + 12 * Math.cos(r)} y1={170 + 12 * Math.sin(r)}
          x2={55 + 18 * Math.cos(r)} y2={170 + 18 * Math.sin(r)} stroke={DT.varColor} strokeWidth="0.8" />;
      })}
      <Line x1={55} y1={170} x2={55 + 12} y2={170 - 8} stroke={DT.varColor} strokeWidth="1.6" />
      <Circle cx={55} cy={170} r={2} fill={DT.varColor} />
      <SvgText x={55} y={200} fill={DT.varColor} fontSize="8" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">gas meter</SvgText>

      {/* Gas pipe to burner */}
      <Line x1={75} y1={170} x2={bx} y2={170} stroke={DT.stroke} strokeWidth="5" />
      <Line x1={75} y1={170} x2={bx} y2={170} stroke="#FFB347" strokeWidth="2" opacity={0.7} />
      <Polygon points={`${bx - 4},170 ${bx - 12},166 ${bx - 12},174`} fill={DT.arrow} />

      {/* Burner flame inside */}
      <Path d={`M${bx + bw / 2 - 12},${by + bh - 20} Q${bx + bw / 2},${by + bh - 52} ${bx + bw / 2 + 12},${by + bh - 20} Q${bx + bw / 2 + 5},${by + bh - 28} ${bx + bw / 2},${by + bh - 18} Q${bx + bw / 2 - 5},${by + bh - 28} ${bx + bw / 2 - 12},${by + bh - 20} Z`}
        fill="#FF6B1A" opacity={0.6} stroke="#FF6B1A" strokeWidth="0.6" />

      {/* Flue */}
      <Rect x={bx + bw / 2 - 10} y={35} width={20} height={by - 35} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.4" />
      <SvgText x={bx + bw / 2 + 18} y={55} fill={DT.desc} fontSize="8" fontFamily={DT.mono}>flue</SvgText>

      {/* Heat output arrow */}
      <Line x1={bx + bw} y1={by + 40} x2={320} y2={by + 40} stroke={DT.stroke} strokeWidth="7" strokeLinecap="square" />
      <Line x1={bx + bw} y1={by + 40} x2={320} y2={by + 40} stroke="rgba(255,107,26,0.55)" strokeWidth="3.5" strokeLinecap="square" />
      <Polygon points={`318,${by + 40} 310,${by + 36} 310,${by + 44}`} fill={DT.arrow} />

      {/* HHV badge */}
      <Rect x={bx + 20} y={by + 10} width={80} height={18} fill="rgba(0,0,0,0.5)" stroke={DT.varColor} strokeWidth="0.6" />
      <SvgText x={bx + 60} y={by + 22} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">HHV (BTU/MCF)</SvgText>

      {/* Labels */}
      <LeaderLine x1={55} y1={190} x2={20} y2={220} varName="MCF/h" desc="fuel rate" anchor="start" />
      <LeaderLine x1={bx + 60} y1={by + 22} x2={20} y2={50} varName="HHV" desc="heating value" anchor="start" />
      <LeaderLine x1={310} y1={by + 40} x2={330} y2={215} varName="BTU/h" desc="heat input rate" anchor="end" />

      <FormulaTag formula="BTU/h = (MCF/h) · HHV    (natural gas ≈ 1,000,000 BTU/MCF)" />
    </DiagramCanvas>
  );
}
